//#region Angular Imports

import { StateProvider, StateService } from '@uirouter/angularjs'

//#endregion

import { Activity, Enums } from '../../models/common'

import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'
import { default as commonModule, LoggerService } from './../common/common.module'

import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

import { ConfigHelper, IUserSession, UserSession } from '../../helpers'
import { OpOperator } from '../../models/core/op-operator'

import { SERVICES_MODULE_NAME } from './../../services'
import { PROVIDER_NAME as SYSTEM_SERVICE_PROVIDER_NAME, SystemServiceProvider, $SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, SYSTEM_SERVICE_NAME, SystemService, SYSTEM_CONTEXT_LIST_SERVICE_NAME, SystemContextListService } from '../../services/system'
import { GRID_SERVICE_NAME, GRID_CONTEXT_MENU_SERVICE_NAME, GridService, GridContextMenuService } from '../../services/grid'
import { USER_SESSION_SERVICE_NAME } from '../../services/user-session'

import { ConsumerController, ConsumerScope } from './consumers.controller'
import { ConsumerDetailsDirective } from './details/consumers-details.directive'
import { ConsumerCreateEditDirective } from './create-edit/consumers-create-edit.directive'
import { ConsumerDetailsNotificationsComponent } from './details/notifications/consumers-details-notifications.component'
import { ConsumerDetailsPaymentsComponent } from './details/payments/consumers-details-payments.component'
import { ConsumerHelper } from './consumers.helper'

//#region Asset Imports

import * as TEMPLATE from './consumers.tpl.html'

//#endregion

// #region Consts

const CONTROLLER_NAME: string = 'ConsumerController'
const DETAILS_DIRECTIVE_NAME: string = 'consumerDetails'
const CREATE_EDIT_DIRECTIVE_NAME: string = 'consumerCreateEdit'
const MENU_INDEX = 16

const NOTIFICATIONS_COMPONENT_NAME: string = 'consumerDetailsNotifications'
const PAYMENTS_COMPONENT_NAME: string = 'consumerDetailsPayments'

const MODULE_NAME: string = 'simax.consumers'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'CONSUMER_NAME'
const STATE_NAME: string = 'consumers'
const STATE_URL: string = '/consumers'

// #endregion


// #region Setup

const module = angular.module(MODULE_NAME, [commonModule, apiModule, SERVICES_MODULE_NAME])

module.controller(CONTROLLER_NAME, [
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    'api',
    'logger',
    'localDictionary',
    GRID_CONTEXT_MENU_SERVICE_NAME,
    USER_SESSION_SERVICE_NAME,
    GRID_SERVICE_NAME,
    SYSTEM_SERVICE_NAME,
    (
        $scope: ConsumerScope,
        $state: StateService,
        $timeout,
        api: Api,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        gridContextMenuService: GridContextMenuService,
        userSession: IUserSession,
        gridService: GridService,
        systemService: SystemService
    ) => new ConsumerController(
        $scope,
        $state,
        $timeout,
        api,
        logger,
        localDictionary,
        gridContextMenuService,
        userSession,
        gridService,
        systemService,
        ConsumerHelper.REFERENCE_TYPE,
        ConsumerHelper.SIMAX_MODULE_NAME
    )])


module.directive(DETAILS_DIRECTIVE_NAME, [() => new ConsumerDetailsDirective()])
module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new ConsumerCreateEditDirective()])
module.component(NOTIFICATIONS_COMPONENT_NAME, new ConsumerDetailsNotificationsComponent())
module.component(PAYMENTS_COMPONENT_NAME, new ConsumerDetailsPaymentsComponent())


module.config(["$stateProvider", 'userSessionProvider', SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionProvider: UserSession,
    systemServiceProvider: SystemServiceProvider
) => {

    systemServiceProvider.registerDetailsComponent({
        key: 'Consumer_IdConsumer',
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.CONSUMER_LIST)
                && !loggedOperator.hasPermission(Activity.CONSUMER_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.ConsumerModule)) {

                MenuItem.addMenuItem(
                    ConfigHelper.getIconName(ConfigHelper.Icon.CONTACT_MAIL),
                    'consumers',
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME,
                    MENU_INDEX
                )

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLLER_NAME,
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}])

// #endregion

export default MODULE_NAME